import { render, staticRenderFns } from "./RewardListNewLayout.vue?vue&type=template&id=a398b79e&scoped=true"
import script from "./RewardListNewLayout.vue?vue&type=script&lang=js"
export * from "./RewardListNewLayout.vue?vue&type=script&lang=js"
import style0 from "./RewardListNewLayout.vue?vue&type=style&index=0&id=a398b79e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a398b79e",
  null
  
)

export default component.exports